import { render, staticRenderFns } from "./UploadDraftAppIcon.vue?vue&type=template&id=22a6f4a6"
import script from "./UploadDraftAppIcon.vue?vue&type=script&lang=js"
export * from "./UploadDraftAppIcon.vue?vue&type=script&lang=js"
import style0 from "./UploadDraftAppIcon.vue?vue&type=style&index=0&id=22a6f4a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports